import React from 'react';
import { Page } from '../Page';
import { Shield, Heart, Bone } from 'lucide-react';
export function SupplementMultiVitamin() {
  return <Page pageNumber={14} variant="light" data-id="element-3240" data-mp="3p1kbhrxeogw5">
      <div className="flex flex-col h-full" data-id="element-3241" data-mp="3b2kwlbzp3gd6">
        <div className="mb-6 pt-4" data-id="element-3242" data-mp="3b1jbsfsvnfi9">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-3243" data-mp="3b4nibjttenc3">
            Supplement Spotlight
          </p>
          <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-3244" data-mp="31c85f0xdkoy2">
            Daily Multi-Vitamin
          </h1>
          <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-3245" data-mp="364swvvst6pyf">
            Fill the nutrient gaps that come with eating less
          </p>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-3246" data-mp="2wd56ly7zneyj" />
        </div>

        <div className="mb-8" data-id="element-3247" data-mp="2wbc14m9430s4">
          <h2 className="text-sm font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-3248" data-mp="2idvp8v81qesz">
            Why It Matters on GLP-1
          </h2>
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-3249" data-mp="2nc727etn15ff">
            GLP-1 medications reduce appetite and caloric intake, which
            increases the risk of micronutrient gaps. A comprehensive multi
            fills those gaps as "dietary insurance," especially important when
            eating less food overall. Thorne's multis use highly bioavailable
            forms without unnecessary additives, maximizing absorption even with
            smaller meals.
          </p>
        </div>

        {/* 3 Bottles Row */}
        <div className="grid grid-cols-3 gap-6 mb-8" data-id="element-3250" data-mp="epms44p603sp">
          <div className="flex flex-col items-center" data-id="element-3251" data-mp="9u7hdlmgeo0i">
            <img src="https://cdn.magicpatterns.com/uploads/cVkBKeTkhs1FfSNaZuZQaq/pasted-image.png" alt="Basic Nutrients 2/Day" className="h-40 object-contain mb-4" data-id="element-3252" data-mp="ohsmtm6swzbl" />
            <h3 className="text-sm font-bold text-[#1F1F1F] text-center mb-1" data-id="element-3253" data-mp="3s63zn57q5w3z">
              Basic Nutrients 2/Day
            </h3>
            <p className="text-[10px] text-[#7A7A70] text-center uppercase tracking-wider" data-id="element-3254" data-mp="3n79h84do69ke">
              All Adults
            </p>
          </div>
          <div className="flex flex-col items-center" data-id="element-3255" data-mp="1w3hdtct636ej">
            <img src="https://cdn.magicpatterns.com/uploads/oATeeYw3b3m4kzEqAuzdQa/pasted-image.png" alt="Men's Multi 50+" className="h-40 object-contain mb-4" data-id="element-3256" data-mp="1w1wj9n6urngo" />
            <h3 className="text-sm font-bold text-[#1F1F1F] text-center mb-1" data-id="element-3257" data-mp="24y5fyu3g47z4">
              Men's Multi 50+
            </h3>
            <p className="text-[10px] text-[#7A7A70] text-center uppercase tracking-wider" data-id="element-3258" data-mp="1d4lj80decq06">
              Men 50+
            </p>
          </div>
          <div className="flex flex-col items-center" data-id="element-3259" data-mp="1h4x3hc1ukob4">
            <img src="https://cdn.magicpatterns.com/uploads/9fk743VWayU2KFEujmpVDA/pasted-image.png" alt="Women's Multi 50+" className="h-40 object-contain mb-4" data-id="element-3260" data-mp="1m5bg77ee8mfh" />
            <h3 className="text-sm font-bold text-[#1F1F1F] text-center mb-1" data-id="element-3261" data-mp="2xjxablarl8xq">
              Women's Multi 50+
            </h3>
            <p className="text-[10px] text-[#7A7A70] text-center uppercase tracking-wider" data-id="element-3262" data-mp="37o5dams4fkqc">
              Women 50+
            </p>
          </div>
        </div>

        {/* Comparison Cards */}
        <div className="grid grid-cols-3 gap-4 mb-6" data-id="element-3263" data-mp="2xxap3cvbeb29">
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 flex flex-col" data-id="element-3264" data-mp="2txiaojj8paoz">
            <Shield className="w-5 h-5 text-tealslate mb-3" data-id="element-3265" data-mp="2oy5qy7no0jqm" />
            <p className="text-xs text-[#3B3B3B] leading-[1.6] mb-4 flex-1" data-id="element-3266" data-mp="2ozqkpv25nynf">
              Simplified daily coverage. Includes chromium for blood sugar
              support and highly absorbable zinc bisglycinate.
            </p>
            <div className="border-t border-[#D8D8D0] pt-3 mt-auto" data-id="element-3267" data-mp="2f1swv8o7k3vc">
              <p className="text-[11px] font-bold text-[#1F1F1F]" data-id="element-3268" data-mp="2azz21h0p1u33">2 caps/day</p>
              <p className="text-[10px] text-[#7A7A70]" data-id="element-3269" data-mp="d7l8aub1wf6x">60 caps per bottle</p>
            </div>
          </div>

          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 flex flex-col" data-id="element-3270" data-mp="97j7soh1xrt8">
            <Heart className="w-5 h-5 text-tealslate mb-3" data-id="element-3271" data-mp="gb9bn3x2lekd" />
            <p className="text-xs text-[#3B3B3B] leading-[1.6] mb-4 flex-1" data-id="element-3272" data-mp="l9ap99bq8log">
              Prostate and heart focus. Includes lycopene and zinc for prostate
              health, plus magnesium for muscle support.
            </p>
            <div className="border-t border-[#D8D8D0] pt-3 mt-auto" data-id="element-3273" data-mp="bad3uf9ll89o">
              <p className="text-[11px] font-bold text-[#1F1F1F]" data-id="element-3274" data-mp="3tp465p9yzz61">6 caps/day</p>
              <p className="text-[10px] text-[#7A7A70]" data-id="element-3275" data-mp="3tnb0ac76liz3">180 caps per bottle</p>
            </div>
          </div>

          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 flex flex-col" data-id="element-3276" data-mp="3jqy9bm30tj81">
            <Bone className="w-5 h-5 text-tealslate mb-3" data-id="element-3277" data-mp="3jovb4erpsjs8" />
            <p className="text-xs text-[#3B3B3B] leading-[1.6] mb-4 flex-1" data-id="element-3278" data-mp="3or2n34cjnzuk">
              Bone support focus. Includes Vitamins D3 and K2. Iron-free formula
              designed for postmenopausal women.
            </p>
            <div className="border-t border-[#D8D8D0] pt-3 mt-auto" data-id="element-3279" data-mp="3fojowxjpeben">
              <p className="text-[11px] font-bold text-[#1F1F1F]" data-id="element-3280" data-mp="2w4m62rskho5f">6 caps/day</p>
              <p className="text-[10px] text-[#7A7A70]" data-id="element-3281" data-mp="2r4zt8jgni9x5">180 caps per bottle</p>
            </div>
          </div>
        </div>

        <div className="mt-auto flex items-center gap-3" data-id="element-3282" data-mp="3550va28njne7">
          <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-3283" data-mp="312w377xuqyto" />
          <div data-id="element-3284" data-mp="3a441vr4a61oa">
            <p className="text-xs font-bold text-[#1F1F1F]" data-id="element-3285" data-mp="3a2j65y68ccou">Choose Your Fit</p>
            <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-3286" data-mp="3osi1zuabbc15">
              If you're interested in a supplement plan tailored to you, check
              out the link below! Fullscript provides third-party tested, safe
              and effective supplements to help get your health where you want
              it at wholesale prices.
            </p>
          </div>
        </div>
      </div>
    </Page>;
}